import React from "react";
import SVG from 'react-inlinesvg';

class GIESvgIcon extends React.Component<any, any> {
  render() {
    const {icon, big, ...p} = this.props;
    return (
      <div className={`svg-icon ${big ? 'big' : ''}`}>
        <SVG src={icon} width="100%" height="100%" {...p}/>
      </div>
    )
  }
}

export default GIESvgIcon;
